import { useEffect } from "react";
import { FriendList } from "./FriendList";
import { useSelector } from "react-redux";
import { RootState } from "@/store/reducers";
import { useLazyGetFriendSuggestionsQuery } from "@/services/modules/chat";
import FriendSuggestion from "./FriendSuggestion";

export const FriendSuggestionList = () => {
  const [getFriendsData] = useLazyGetFriendSuggestionsQuery();
  const allFriendsList = useSelector(
    (state: RootState) => state.chat.friendSuggestionList
  );

  useEffect(() => {
    getFriendsData();
  }, []);

  return (
    <FriendList
      friendList={allFriendsList}
      Item={({ item }) => <FriendSuggestion recipient={item} />}
    />
  );
};
